module.exports = __webpack_public_path__ + "static/media/JosefinSlab-ThinItalic.766ebb44.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/JosefinSlab-ThinItalic.ttf
// module id = 3159
// module chunks = 71